import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Option, Response, StaticMethods} from '../../model/GeneralModels';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PetService} from '../../services/pet.service';

class VisitTypeDialogData {
  requestID: number;
}

@Component({
  selector: 'app-visit-type-dialog',
  templateUrl: './visit-type-dialog.component.html',
  styleUrls: [
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css'
  ]
})
export class VisitTypeDialogComponent implements OnInit {
  formGroup: FormGroup = this.fb.group({
    visitType: ['', Validators.required],
  });
  requestID: number;
  typesList: Option[] = [];

  constructor(
    public dialogRef: MatDialogRef<VisitTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VisitTypeDialogData, private fb: FormBuilder,
    private petService: PetService) {
  }

  ngOnInit(): void {
    this.requestID = this.data.requestID;
    this.petService.getAvailableVisitTypes(this.requestID).subscribe(response => {
      if (response.success) {
        this.typesList = [];
        response.data.forEach(type => {
          this.typesList.push(type);
        });
      }
    });
  }

  submit() {
    if (this.formGroup.valid) {
      this.petService.submitVisitType(this.requestID, this.formGroup.controls.visitType.value).subscribe(response => {
        if (response.success) {
          this.dialogRef.close(true);
        }
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
